import React from 'react';
import StepHeader from './StepHeader';
import { Field, Input, PhoneInput } from '../../lib/ui/Field';
import { ErrorBanner } from '../../lib/ui/Feedback';
import Button from '../../lib/ui/Button';

export default function AuthStep({
  authStep, authName, setAuthName, authPhone, setAuthPhone,
  authEmail, setAuthEmail, consent, setConsent,
  authOtp, otpRefs, normPhone, authLoading, authError, resendLeft,
  upiSettings, cart, total, te, L,
  handleSendOtp, handleOtpChange, handleOtpKey, handleVerifyOtp, handleResend,
  onClose, authOnly, onChangeNumber,
}) {
  return (
    <div>
      <StepHeader
        title={authStep === 'form'
          ? `👋 ${authOnly ? L('Sign In / Sign Up', 'సైన్ ఇన్') : L('Sign in to Order', 'ఆర్డర్ చేయడానికి సైన్ ఇన్')}`
          : `📲 ${L('Verify OTP', 'OTP నిర్ధారించండి')}`}
        sub={authStep === 'otp'
          ? `Sent to +91 ${normPhone.replace('+91', '')}`
          : upiSettings.otp_required === false
            ? L('Enter your details to continue', 'మీ వివరాలు నమోదు చేయండి')
            : L('One-time password — no password needed', 'OTP ద్వారా లాగిన్')}
        onClose={onClose}
      />

      {!authOnly && total > 0 ? (
        <div className="bg-brand-light/50 border border-brand-light rounded-xl px-3.5 py-2.5 mb-4 text-sm">
          🛒 {cart.length} {L('items', 'వస్తువులు')} · <strong>₹{total.toFixed(2)}</strong>
        </div>
      ) : null}

      {authStep === 'form' ? (
        <>
          <Field label="Your Name">
            <Input placeholder="Full name" value={authName} onChange={(e) => setAuthName(e.target.value)} autoFocus />
          </Field>
          <Field label="Mobile Number">
            <PhoneInput value={authPhone} onChange={(e) => setAuthPhone(e.target.value.replace(/[^0-9 ]/g, ''))} onKeyDown={(e) => e.key === 'Enter' && handleSendOtp()} />
          </Field>
          <Field label={<span>Email <span className="text-[11px] font-medium text-ink-faint bg-black/5 rounded-full px-1.5 py-0.5 ml-1">optional</span></span>}>
            <Input type="email" placeholder="you@example.com" value={authEmail} onChange={(e) => setAuthEmail(e.target.value)} />
          </Field>
        </>
      ) : null}

      {authStep === 'otp' ? (
        <>
          <div className="flex justify-center gap-2 my-3">
            {authOtp.map((v, i) => (
              <input
                key={i}
                ref={(el) => { otpRefs.current[i] = el; }}
                value={v}
                maxLength={1}
                inputMode="numeric"
                onChange={(e) => handleOtpChange(i, e.target.value)}
                onKeyDown={(e) => handleOtpKey(i, e)}
                className={`w-11 h-[52px] text-center text-xl font-black rounded-xl border-2 outline-none ${v ? 'border-brand text-brand-dark' : 'border-black/10'}`}
              />
            ))}
          </div>
          <div className="text-center mb-3">
            {resendLeft > 0 ? (
              <span className="text-ink-faint text-sm">Resend in {resendLeft}s</span>
            ) : (
              <button type="button" onClick={handleResend} className="text-sky-700 font-bold text-sm underline">🔄 Resend OTP</button>
            )}
          </div>
          <Button fullWidth loading={authLoading} disabled={authOtp.join('').length < 6} onClick={() => handleVerifyOtp()}>
            {authLoading ? 'Verifying…' : '✅ Verify & Continue'}
          </Button>
          <button type="button" onClick={onChangeNumber} className="w-full mt-2.5 text-center text-ink-faint text-sm font-bold">← Change number</button>
        </>
      ) : null}

      <ErrorBanner>{authError}</ErrorBanner>

      {authStep === 'form' ? (
        <>
          <label className="flex items-start gap-2.5 bg-brand-light/40 border border-black/5 rounded-xl px-3 py-2.5 mt-2 mb-2 cursor-pointer">
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 h-4 w-4 accent-brand shrink-0" />
            <span className="text-xs text-ink-soft leading-relaxed">
              {L(
                'I agree to the collection of my name, phone and address for order processing and delivery. I consent to receive order updates via WhatsApp.',
                'నా పేరు, ఫోన్ నంబర్, చిరునామా ఆర్డర్ ప్రాసెసింగ్ కోసం సేకరించడానికి నేను అంగీకరిస్తున్నాను. WhatsApp ద్వారా ఆర్డర్ అప్డేట్లు స్వీకరించడానికి అంగీకరిస్తున్నాను.',
              )}
            </span>
          </label>
          <Button fullWidth loading={authLoading} disabled={!consent} onClick={handleSendOtp}>
            {authLoading ? 'Please wait…' : upiSettings.otp_required === false ? L('Continue →', 'కొనసాగించు →') : L('📩 Send OTP →', '📩 OTP పంపు →')}
          </Button>
        </>
      ) : null}
    </div>
  );
}
